export const maskMoney = (money: string | number, decimals: number = 2) => {
  if (isNaN(Number(money))) return 0;
  let val: string;
	val = money.toString().replace(/\D/g, '');
	if (decimals > 0) {
		val = val.replace(new RegExp(`(\\d)(\\d{${decimals}})$`), '$1,$2');
	}
	val = val.replace(/(?=(\d{3})+(\D))\B/g, '.');
	return val;
};
